import React from "react";
import { Button } from "@material-ui/core";
import { useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import Dropdown from "../../Dropdown/Dropdown";
import secureLocalStorage from "react-secure-storage";

const urls = [
  {
    id: 1,
    value: "https://erp-testlive.sevenrocks.in/v2-web-api",
    label: "Test Service",
  },
  {
    id: 2,
    value: "https://erp.sevenrocks.in/v2-web-api",
    label: "Live Service",
  },
  {
    id: 3,
    value: "https://staging.sevenrocks.in/v2-web-api",
    label: "Staging Service",
  },
];

const BaseUrl = (props) => {
  const { close } = props;

  const [value, setValue] = useState("");
  const [url_value, setUrlValue] = useState("");

  const handleUrl = (option) => {
    // console.log(option);
    setValue(option?.label);
    setUrlValue(option?.value);
  };

  const [pass, setPass] = useState("");

  const handleSubmitUrl = async () => {
    await secureLocalStorage.setItem("BaseURI", url_value);
    await close();

    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <>
      <HeadingTitle
        title={"Change BASE URL"}
        center={false}
        closeModal={close}
      />
      {pass === process.env.REACT_APP_PASS ? (
        <div className="base-url-wrapper">
          <Dropdown
            dropdown={urls}
            label="Choose URL"
            placeholder="Choose URL"
            onData={handleUrl}
          />
          <div>
            <Button
              className="change__module"
              disabled={value !== "" && url_value !== "" ? false : true}
              onClick={handleSubmitUrl}
            >
              Submit
            </Button>
          </div>
        </div>
      ) : (
        <div className="password-container">
          <label className="label">Please Enter Password</label>
          <div>
            <input
              type="text"
              id="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BaseUrl;
